import(/* webpackMode: "eager" */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleLinksPreconnect"] */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/src/next-lib/components/google-links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/src/providers/LanguageProvider.tsx");
